module.exports = __webpack_public_path__ + "img/img29.4e30d1f3.png";